import { FormEvent, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Btn from '../components/ui/Btn';
import { ApiError, api } from '../lib/api';
import { useAuthStore } from '../stores/auth';

export default function ChangePasswordPage() {
  const navigate = useNavigate();
  const user = useAuthStore((s) => s.user);

  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState(false);

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError(null);
    if (next !== confirm) {
      setError('Les deux nouveaux mots de passe ne correspondent pas.');
      return;
    }
    if (next.length < 14) {
      setError('Le nouveau mot de passe doit faire au moins 14 caractères.');
      return;
    }
    setSubmitting(true);
    try {
      await api.post('/auth/password/change', {
        current_password: current,
        new_password: next,
      });
      const me = await api.get<typeof user>('/auth/me');
      if (me) {
        useAuthStore.setState((s) => ({ ...s, user: me }));
      }
      setDone(true);
      setTimeout(() => navigate('/dossiers'), 1500);
    } catch (err) {
      setError(
        err instanceof ApiError ? (err.problem.detail ?? err.problem.title) : 'Erreur réseau'
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="mx-auto max-w-md space-y-4">
      <h1 className="font-serif text-[26px] font-medium tracking-[-0.2px] text-text-primary">
        Changer mon mot de passe
      </h1>
      {user?.must_change_password && (
        <p className="rounded-md bg-status-warning-bg px-3 py-2 text-sm text-status-warning-text">
          Ton mot de passe actuel a été émis lors du provisioning et doit être remplacé.
        </p>
      )}
      <form
        onSubmit={onSubmit}
        className="space-y-3 rounded-lg border border-rule bg-paper-elevated p-6 shadow-sm"
      >
        <label className="block">
          <span className="block text-[11px] font-medium uppercase tracking-[1px] text-text-secondary">
            Mot de passe actuel
          </span>
          <input
            type="password"
            value={current}
            onChange={(e) => setCurrent(e.target.value)}
            required
            autoFocus
            className="mt-1.5 w-full rounded-md border border-rule-strong bg-paper-elevated px-3 py-2 text-sm focus:border-accent focus:outline-none"
          />
        </label>
        <label className="block">
          <span className="block text-[11px] font-medium uppercase tracking-[1px] text-text-secondary">
            Nouveau mot de passe
          </span>
          <input
            type="password"
            value={next}
            onChange={(e) => setNext(e.target.value)}
            required
            minLength={14}
            className="mt-1.5 w-full rounded-md border border-rule-strong bg-paper-elevated px-3 py-2 text-sm focus:border-accent focus:outline-none"
          />
          <span className="mt-1 block text-xs text-text-tertiary">
            14 caractères minimum (CdC §9.4).
          </span>
        </label>
        <label className="block">
          <span className="block text-[11px] font-medium uppercase tracking-[1px] text-text-secondary">
            Confirmer le nouveau mot de passe
          </span>
          <input
            type="password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            required
            className="mt-1.5 w-full rounded-md border border-rule-strong bg-paper-elevated px-3 py-2 text-sm focus:border-accent focus:outline-none"
          />
        </label>
        {error && <p className="text-sm text-cat-def">{error}</p>}
        {done && <p className="text-sm text-cat-fav">Mot de passe modifié — redirection…</p>}
        <Btn type="submit" variant="primary" disabled={submitting || done} className="w-full">
          {submitting ? 'Enregistrement…' : 'Mettre à jour'}
        </Btn>
      </form>
    </div>
  );
}
